import { CreditCard } from 'lucide-react'

interface CardBrandMarkProps {
  brand: string
}

const BRAND_STYLES: Record<string, { label: string; color: string }> = {
  visa: { label: 'VISA', color: '#1a1f71' },
  mastercard: { label: 'MC', color: '#eb001b' },
  amex: { label: 'AMEX', color: '#006fcf' },
  discover: { label: 'DISC', color: '#ff6000' },
  diners: { label: 'DINERS', color: '#0079be' },
  jcb: { label: 'JCB', color: '#0e4c96' },
  unionpay: { label: 'UP', color: '#005baa' },
}

/**
 * Small brand mark for a payment card. Outlined card-like treatment with the
 * brand short-code in the brand's own color — reads as a card badge rather
 * than a filled button.
 */
export function CardBrandMark({ brand }: CardBrandMarkProps) {
  const config = BRAND_STYLES[brand.toLowerCase()]

  if (!config) {
    return (
      <div className="flex h-12 w-16 items-center justify-center rounded bg-muted">
        <CreditCard
          className="text-muted-foreground h-5 w-5"
          aria-label={brand}
        />
      </div>
    )
  }

  return (
    <div
      className="flex h-12 w-16 items-center justify-center rounded bg-muted"
      aria-label={config.label}
    >
      <span
        className="font-fragment-mono text-xs font-bold tracking-[0.08em]"
        style={{ color: config.color }}
      >
        {config.label}
      </span>
    </div>
  )
}
